import { useState, useEffect } from "react";
import Modal from "./Modal";
import { FaExclamationTriangle, FaArrowRight } from "react-icons/fa";

const AuthModal = ({ 
  isOpen, 
  onClose, 
  redirectPath = "/login",
  countdownStart = 10
}) => {
  const [countdown, setCountdown] = useState(countdownStart);

  useEffect(() => {
    if (!isOpen) {
      setCountdown(countdownStart);
      return;
    }

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          window.location.href = redirectPath;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isOpen, redirectPath, countdownStart]);

  const handleRedirectNow = () => {
    window.location.href = redirectPath;
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Login Required"
      icon={<FaExclamationTriangle />}
      type="warning"
      overlayClose={false}
    >
      <div className="space-y-4">
        <p className="text-gray-700">
          You need to be logged in to perform this action. You'll be automatically 
          redirected to the login page in {countdown} seconds.
        </p>
        
        <div className="flex justify-end gap-3 pt-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleRedirectNow}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2"
          >
            Go to Login Now <FaArrowRight />
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AuthModal;